export { default } from './Capsule';
